<template>
    <div class="smooth-scroll-container">
        <div class="pane-content-with-sidebar">
            <div class="pane-content-with-sidebar__left">
                <ui-tab-list :tabs="tabs" :active="active" class="pane-content-with-sidebar__left__fixed" />
            </div>
            <div class="pane-content-with-sidebar__right">
                <pane-content>
                    <slot></slot>
                </pane-content>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import _ from 'underscore';

    export default {
        name: 'pane-content-with-sidebar',
        props: ['updateWhenThisValueChanges'],
        mounted() {
            this.container = this.$el;
            this.container.addEventListener('scroll', this.onScroll);
            this.tabs = this.slotsToTabs;
            this.setAsActive(0);
        },
        data() {
            return {
                tabs: [],
                tabPositions: [],
                active: null,
                scrollDetection: true,
            }
        },
        watch: {
            tabs() {
                this.updatePositions();
            },
            updateWhenThisValueChanges() {
                this.updatePositions();
            },
            scrollDetection() {
                setTimeout(() => {
                    this.updatePositions();
                    this.scrollDetection = true;
                }, 500);
            },
        },
        computed: {
            slotsToTabs() {
                return this.$slots.default.filter(s => typeof s.tag !== 'undefined').map((t, i) => {
                    const propsData = t.componentOptions.propsData;
                    const title = t.componentOptions.propsData.title;
                    return {
                        onClick: () => {
                            this.scrollDetection = false;
                            this.setAsActive(i);
                        },
                        title,
                        href: '#' + this.slugify(title.toLowerCase()),
                        el: t.elm,
                        propsData,
                    }
                });
            },
        },
        methods: {
            slugify(text) {
                return text.toString().toLowerCase()
                .replace(/\s+/g, '-')           // Replace spaces with -
                .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
                .replace(/\-\-+/g, '-')         // Replace multiple - with single -
                .replace(/^-+/, '')             // Trim - from start of text
                .replace(/-+$/, '');            // Trim - from end of text
            },
            updatePositions() {
                setTimeout(() => {
                    this.tabPositions = this.tabs.map((tab, index) => {
                        return {
                            offsetTop: tab.el.offsetTop,
                        };
                    });
                }, 50);
            },

            onScroll: function() {
                const tabs = this.tabs;
                const scrollTop = this.container.scrollTop + 49;
                const tabPositions = this.tabPositions;
                if (this.scrollDetection) {
                    for (var i = 0; i < tabPositions.length; i++) {
                        const tabPosition = tabPositions[i];
                        if (tabPosition.offsetTop <= scrollTop) {
                            this.setAsActive(i, false);
                        }
                    }
                }
            },
            setAsActive(index, scrollIntoView = true) {
                this.handleActiveState(this.tabs[index], scrollIntoView);
                this.active = index;
            },
            handleActiveState(tab, scrollIntoView) {
                const { el } = tab;
                el.classList.remove('collapsed');
                Vue.set(tab.propsData, 'isCollapsed', false);

                // if (scrollIntoView) {
                //     el.scrollIntoView({
                //         behavior: 'smooth',
                //         block: 'nearest',
                //     });
                // }
            },
        },
    };
</script>

<style>
    .smooth-scroll-container {
        height: 100%;
        overflow: auto;
        scroll-behavior: smooth;
    }

    .pane-content-with-sidebar {
        display: flex;
        min-height: 100%;
    }
    .pane-content-with-sidebar__left {
        flex: 0 0 200px;
        border-right: 1px solid rgba(0, 0, 0, .1);
    }
    .pane-content-with-sidebar__right {
        flex: 1;
    }

    .pane-content-with-sidebar__left__fixed {
        position: fixed;
        width: 200px;
    }

    @media (max-width: 800px) {
        .pane-content-with-sidebar__left {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// PaneContentWithSidebar.vue?478e84e6